import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Dienst} from '../dienst';
import {Categorie} from '../categorie';
import {TaakType} from '../taak';
import {Diensten} from '../diensten';
import {MatSelectChange} from '@angular/material/select';
import User from '../../core/auth/user';
import {Client} from '../../client/client';
import {Zone} from '../../zone/zone';
import {ClientDienst} from '../../client/client-dienst';

@Component({
    selector: 'zah-diensten-navigation',
    templateUrl: './diensten-navigation.component.html',
    styleUrls: ['./diensten-navigation.component.scss'],
    standalone: false
})
export class DienstenNavigationComponent implements OnInit {

  @Input()
  user: User;
  @Input()
  client: Client;
  @Input()
  diensten: Diensten;
  @Input()
  zones: Array<Zone>;
  @Input()
  isPrestatiePage: boolean;
  @Output()
  meldingenClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  prestatieClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  signaalkaartClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  wijzigClientClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  clientFicheClicked: EventEmitter<void> = new EventEmitter<void>();
  @Output()
  categorieSelected: EventEmitter<[Dienst, TaakType, Categorie]> = new EventEmitter<[Dienst, TaakType, Categorie]>();

  selectedDienstId: string;
  selectedClientDienst: ClientDienst;
  selectedDienst: Dienst;
  private selectedCategorie: Categorie;
  private selectedTaakType: TaakType;

  ngOnInit(): void {
    if (!this.diensten.isEmpty()) {
      this.selectDienst(this.diensten.getFirst());
    }
  }

  onMeldingenClicked(): void {
    this.meldingenClicked.emit();
  }

  onPrestatieClicked(): void {
    this.prestatieClicked.emit();
  }

  onSignaalkaartClicked(): void {
    this.signaalkaartClicked.emit();
  }

  onWijzigClientClicked(): void {
    this.wijzigClientClicked.emit();
  }

  onClientFicheClicked(): void {
    this.clientFicheClicked.emit();
  }

  changeDienst(change: MatSelectChange): void {
    this.selectDienst(this.diensten.getDienst(change.value));
  }

  private selectDienst(dienst: Dienst): void {
    this.selectedDienst = dienst;
    this.selectedClientDienst = this.client.getDienst(dienst.getId());
    this.selectedDienstId = dienst.getId();
    const firstTaakType = dienst.getTaakTypes()[0];
    const firstCategorie = dienst.getCategorieenByType(firstTaakType)[0];
    this.selectCategory(firstTaakType, firstCategorie);
  }

  selectCategory(taakType: TaakType, categorie: Categorie): void {
    this.selectedCategorie = categorie;
    this.selectedTaakType = taakType;
    this.categorieSelected.emit([
      this.selectedDienst,
      this.selectedTaakType,
      this.selectedCategorie,
    ]);
  }

  isSelected(taakType: TaakType, categorie: Categorie): boolean {
    return taakType === this.selectedTaakType
      && categorie.hasId(this.selectedCategorie.getId());
  }
}
